import React, { useEffect, useState, useContext } from "react";
import { useDropzone } from "react-dropzone";
import "./dropInputStyles.css";
import * as Sentry from "@sentry/react";
import { Typography, makeStyles, CircularProgress } from "@material-ui/core";

import { CoinContext } from "../../contexts/CoinContext";

export default function DropInput(props) {
  const classes = useStyles();
  const [files, setFiles] = useState([]);
  const { label, fluid, loading, imgUrl } = props;

  const { handleClickAlert } = useContext(CoinContext);

  const { getRootProps, getInputProps } = useDropzone({
    accept: props.label === "Video" ? "video/*" : "image/*",
    multiple: false,
    maxSize: 5242880, // bytes -> 5mb
    onDropAccepted: (acceptedFiles) => {
      props.upload(acceptedFiles);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
    onDropRejected: (error) => {
      // props.onError();
      console.error(error); // alert("The file exceeds the size limit.");
      // console.log(error[0].errors[0].code)
      if (error[0].errors[0].code === "file-invalid-type") {
        handleClickAlert("error", "Please upload .jpg or .png file only");
      } else if (error[0].errors[0].code === "file-too-large") {
        handleClickAlert("error", "Image size exceeds 5mb");
      } else {
        handleClickAlert("error", "Upload failed. Try again");
      }
    },
  });

  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt="preview" />
      </div>
    </div>
  ));

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <>
      {label === "Edit" ? null : (
        <Typography component="p" className={classes.dropInputLabel}>
          {label}
        </Typography>
      )}

      {imgUrl ? (
        <img
          src={imgUrl}
          className={fluid ? "container-is-fluid" : "container"}
          alt="preview"
        />
      ) : (
        <section
          className={
            fluid
              ? "container-is-fluid"
              : label === "Edit"
              ? "circular-container"
              : "container"
          }
        >
          {loading ? (
            <div className={classes.uploadingOverlay}>
              <CircularProgress color="secondary" />
            </div>
          ) : null}
          <div
            {...getRootProps({
              className: fluid ? "dropzone-fluid" : "dropzone",
            })}
          >
            <input {...getInputProps()} />
            {files.length === 0 ? (
              label === "Edit" ? (
                <Typography className={classes.centeredText} variant="body2">
                  Edit
                </Typography>
              ) : (
                <Typography className={classes.centeredText} variant="body2">
                  Drag and drop a file here or{" "}
                  <span className="special-strong">browse</span> and upload
                </Typography>
              )
            ) : null}
            <aside style={fluid ? thumbsContainerFluid : thumbsContainer}>
              {thumbs}
            </aside>
          </div>
        </section>
      )}
    </>
  );
}

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  height: "200px",
  width: "200px",
};

const thumbsContainerFluid = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  height: "100%",
  width: "100%",
};

const thumb = {
  display: "inline-flex",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "100%",
  height: "100%",
};

const useStyles = makeStyles((theme) => ({
  centeredText: {
    position: "absolute",
    textAlign: "center",
    width: "100%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.palette.text.primary,
    opacity: 0.7,
  },
  dropInputLabel: {
    color: theme.palette.text.primary,
    opacity: "0.4",
    textTransform: "uppercase",
    // paddingBottom: "10px",
    fontSize: "1rem",
    fontWeight: "bold !important",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
  },
  uploadingOverlay: {
    position: "absolute",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "1000",
    backgroundColor: "#00000040",
  },
}));
